import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

interface propiedades {
  estadoVisibilidad: boolean;
  cambiarVisibilidad: React.Dispatch<React.SetStateAction<boolean>>;
  contenidoModal: string;
  titulo: string;
  actionForModal: () => Promise<void>;
  onClose: () => void | Promise<void>;
  labelForAction: string;
}

const ModalWindow = (props: propiedades) => {
  const {
    estadoVisibilidad,
    cambiarVisibilidad,
    contenidoModal,
    titulo,
    actionForModal,
    labelForAction,
    onClose,
  } = props;

  const toggleModal = () => cambiarVisibilidad(!estadoVisibilidad);

  return (
    <Modal isOpen={estadoVisibilidad} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>{titulo}</ModalHeader>
      <ModalBody>
        <div dangerouslySetInnerHTML={{__html: contenidoModal}}></div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={() => {
            toggleModal();
            onClose();
          }}
        >
          Cerrar
        </Button>
        <Button color="primary" onClick={actionForModal}>
          {labelForAction}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalWindow;
